var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.name},[_c('div',{class:(_vm.name + "__label")},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{class:(_vm.name + "__split")},[_vm._v(":")]),_vm._v(" "),_c('div',{class:(_vm.name + "__value")},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }